import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';

const styles = css`
  padding: 45px 0 60px;
  background-color: #45A1C8;
  @media (min-width: 992px) {
    padding: 60px 0 90px;
  }
  .Sponsor_sectionHeading {
    font-size: 21px;
    font-weight: 700;
    text-align: center;
    color: #FFFFFF;
    margin: 0 0 45px 0;
  }
  .Sponsor {
    text-align: center;
    display: flex;
    align-items: center;
    height: 100%;
    justify-content: center;
    padding: 0;
    margin: 0 0 30px 0;
  }
  .SponsorImage {
    width: 50%;
    margin-bottom: 70px;
    @media (min-width: 992px) {
      width: 80%;
      margin-bottom: 0;
    }
    @media (min-width: 1201px) {
      width: 100%;
      margin-bottom: 0;
    }
  }
`;

function SponsorBanner({ widget }) {
  return (
    <div className={styles}>
      <h3 className="Sponsor_sectionHeading">Our Event Sponsors</h3>
      <div className="container">
        <div className="row justify-content-lg-center justify-content-xl-between">
          {
            widget.cta_button.map(cta => (
              <div key={get(cta, 'image.contentUrl')} className="col-lg-4 col-xl-2">
                <div className="Sponsor">
                  <img src={get(cta, 'image.contentUrl')} className="SponsorImage" alt={get(cta, 'title')} />
                </div>
              </div>
            ))
          }
        </div>
      </div>
    </div>
  );
}
SponsorBanner.propTypes = {
  widget: PropTypes.object.isRequired,
};
export default withData({
  widget: 'sponsor_banner',
})(SponsorBanner);



// WEBPACK FOOTER //
// ./src/components/SponsorBanner.js